import { workflowEnvCs } from "../locales/parts/workflowActions";
import { i18n } from "./i18n";

const ENV = /\b(on|into) (dev|test|production)\b/;

/**
 * Label or description of a server-sent workflow action, in the user's
 * language. The server only knows English; unknown texts come back as sent.
 * The environment ("on dev", "into production") is lifted out so one
 * translation serves all of them.
 */
export function workflowText(english: string): string;
export function workflowText(english: string | undefined): string | undefined;
export function workflowText(english: string | undefined): string | undefined {
  if (!english) return english;
  const m = ENV.exec(english);
  const env = m?.[2] ?? "";
  const key = m ? english.replace(ENV, "$1 {{env}}") : english;
  const named = i18n.language === "cs" ? workflowEnvCs[env] : undefined;
  return i18n.t(key, {
    ns: "workflow",
    keySeparator: false,
    nsSeparator: false,
    defaultValue: english,
    env: named?.at ?? env,
    envTo: named?.to ?? env,
  });
}
